export default "Here are some possible reasons:\n\n- You’re under 21 years of age.\n- Half year payment intervals are unavailable.\n";